import FilterToggleBar from "../FilterToggleBar/FilterToggleBar";
import GameSlider from "../GameSlider/GameSlider";
import PlayerPositionFilterBar from "./components/PlayerPositionFilterBar/PlayerPositionFilterBar";
import MarketsFilterBar from "./components/MarketsFilterBar/MarketsFilterBar";
import React from "react";
import './FilterBar.Desktop.style.scss';

const FilterBarDesktop = ({vm, isFilterBarOpen, setFilterBarOpen})=>{

    return <div className={`FilterBarDesktop filterBar`}>
        <div className={`summary-filter`}>
            <FilterToggleBar isFilterBarOpen={isFilterBarOpen}
                             setFilterBarOpen={setFilterBarOpen}
                             vm={vm}/>
        </div>
        <div className={`advanced-filter ${isFilterBarOpen ? "open" : "close"}`}>
            <GameSlider vm={vm}/>
            <PlayerPositionFilterBar vm={vm}/>
            <MarketsFilterBar vm={vm}/>
        </div>
    </div>


}
export default FilterBarDesktop;